import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Merge conditional class lists with Tailwind-aware de-duplication. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Format an area in hectares with the pt-PT convention used across the app. */
export function formatAreaHa(areaHa: number): string {
  return `${areaHa.toFixed(2)} ha`
}
